fragment NotificationFragment on Notification {
    id
    type
    destinationEntity {
        ... on Activity {
            id
        }
        ... on Thread {
            id
        }
    }
    triggeringUser {
        id
        name
        avatarUrl
        initials
    }
    readStatus
    content
    preview
    createdTime
    htmlUrl
    entity {
        ... on Activity {
            id
        }
        ... on Lead {
            avatarUrl
            initials
        }
        ... on Contact {
            avatarUrl
            initials
        }
        ... on Reaction {
            reactionType
        }
        ... on Thread {
            threadType
        }
        ... on Message {
            thread {
                threadType
            }
        }
    }
}
